var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmbed = function SvgEmbed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.2 4h-2.4l-4.0002 16h2.4002zm-13.22058 7.2929c-.39053.3905-.39053 1.0237 0 1.4142l3.94974 3.9498.70711.7071 1.41421-1.4143-.7071-.7071-3.24264-3.2426 3.24264-3.24264.7071-.70711-1.41421-1.41421-.70711.70711zm16.09188-3.94975-.7071-.70711-1.4142 1.41421.7071.70711 3.2426 3.24264-3.2426 3.2426-.7071.7071 1.4142 1.4143.7071-.7071 3.9497-3.9498c.3906-.3905.3906-1.0237 0-1.4142z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmbed);
export default ForwardRef;